module.exports = __webpack_public_path__ + "img/medio2.46d792f2.jpg";